import clsx from 'clsx';
/**
 * Creates a string of classes for flex items
 * @param options Flex item options
 * @returns CSS classes
 */
export function getFlexItemClasses(options) {
    const { grow, shrink, alignSelf } = options;
    return clsx({
        'flex-grow': grow === true,
        'flex-grow-0': grow === false,
    }, {
        'flex-shrink': shrink === true,
        'flex-shrink-0': shrink === false,
    }, {
        'self-auto': alignSelf === 'auto',
        'self-start': alignSelf === 'start',
        'self-end': alignSelf === 'end',
        'self-center': alignSelf === 'center',
        'self-stretch': alignSelf === 'stretch',
    });
}
//# sourceMappingURL=getFlexItemClasses.js.map